import { apiClient } from './api';
import type {
  LineLinkRequest,
  LineLinkResponse,
  LineAuthRequest,
  LineAuthResponse,
  LineUnlinkRequest,
  LineUnlinkResponse,
} from '@/types/line';

/**
 * LINE連携を実行する
 * @param request LINE連携リクエスト
 * @returns LINE連携レスポンス
 */
export const linkLine = async (
  request: LineLinkRequest
): Promise<LineLinkResponse> => {
  const response = await apiClient.post<LineLinkResponse>('/v1/line/link', request);
  return response.data;
};

/**
 * LINE認証（ログイン）を実行する
 * @param request LINE認証リクエスト
 * @returns LINE認証レスポンス
 */
export const authLine = async (
  request: LineAuthRequest
): Promise<LineAuthResponse> => {
  const response = await apiClient.post<LineAuthResponse>('/v1/line/auth', request);
  return response.data;
};

/**
 * LINE連携解除（本人）を実行する
 * @param request LINE連携解除リクエスト
 * @returns LINE連携解除レスポンス
 */
export const unlinkLineSelf = async (
  request: LineUnlinkRequest
): Promise<LineUnlinkResponse> => {
  const response = await apiClient.post<LineUnlinkResponse>(
    '/v1/line/unlink/self',
    request
  );
  return response.data;
};
